import flight from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import dot from 'dot/doT';

function TagSuggestions() {
    this.defaultAttrs({
        tagDivider: '\n',
        allowCreateTag: true,
        disallowDefault: false,

        suggestedTagSelector: '[data-tag-suggestions-item]',
        activeSuggestedTagSelector: '[data-tag-suggestions-item][data-active]',
        suggestionListSelector: '[data-tag-suggestions-list]',
        defaultSuggestedTagSelector: '[data-tag-suggestions-item-default]',

        tagSuggestionsItemTemplateSelector: '[data-tag-suggestions-item-template]',
        tagSuggestionsItemDefaultTemplateSelector: '[data-tag-suggestions-item-default-template]',
        tagSuggestionsItemTemplate: '',
        tagSuggestionsItemDefaultTemplate: '',
    });

    // Hide suggestion container if there is no user input data
    this.hideSuggestions = function(event, data) {
        if (data.userString === '' || !data.userString) {
            this.select('suggestionListSelector').removeAttr('data-active');
        }
    };

    // Show suggestion container if user input data is not empty
    this.showSuggestions = function(event, data) {
        if (data.userString !== '') {
            this.select('suggestionListSelector').attr('data-active', true);
        }
    };

    // Show suggestions in list view
    this.showMatchingSuggestions = function(data) {
        const userString = data.userString;
        const suggestions = data.suggestions;
        const existingTags = data.existingTags;

        this.select('suggestionListSelector').html('');

        // Prune existing tags out of suggestions
        existingTags.forEach(element => {
            if ($.inArray(element, suggestions) !== -1) {
                suggestions.splice(suggestions.indexOf(element), 1);
            }
        });

        if (userString !== '') {
            suggestions.forEach(name => {
                if (userString !== name || this.attr.disallowDefault) {
                    this.select('suggestionListSelector').append(this.getSuggestionMarkup(name));
                }
            });

            const { disallowDefault, allowCreateTag } = this.attr;

            if (!disallowDefault) {
                if (!this.isStringInArray(userString, existingTags)) {
                    if (allowCreateTag && !this.isStringInArray(userString, suggestions)) {
                        this.select('suggestionListSelector').append(
                            this.getCreateNewMarkup(userString)
                        );
                    } else {
                        this.select('suggestionListSelector').prepend(
                            this.getDefaultSuggestionElement(userString)
                        );
                    }
                }
            }

            this.trigger('uiSuggestionsReady', {
                userString,
            });
        } else {
            this.trigger('uiSuggestionsEmpty', {
                userString,
            });
        }
    };

    // Check if string is in an array
    this.isStringInArray = function(string, array) {
        return $.inArray(string, array) !== -1;
    };

    // Suggestions data served by data component
    this.suggestionsDataServed = function(event, data) {
        this.showMatchingSuggestions(data);
    };

    // List item selected and trigger ui event
    this.suggestionSelected = function(event, data) {
        const tagName = $(data.el)
            .find('[data-tag-suggestions-item-name]')
            .text()
            .trim();
        this.trigger('uiSuggestionsSelected', {
            tagName,
        });
        this.hideSuggestions(event, data);
    };

    // Create a new suggestion
    this.getSuggestionMarkup = function(name) {
        const templateInput = this.select('tagSuggestionsItemTemplateSelector').html();
        const template = dot.template(templateInput);
        const templateHtml = template({
            name: name.trim(),
        });
        return templateHtml;
    };

    // Create a new suggestion
    this.getCreateNewMarkup = function(name) {
        const templateInput = this.select('tagSuggestionsItemDefaultTemplateSelector').html();
        const template = dot.template(templateInput);
        const templateHtml = template({
            name: name.trim(),
        });
        return templateHtml;
    };

    this.getDefaultSuggestionElement = function(name) {
        const $el = $(
            '<li class="tag-suggestions__item tag-suggestions__item--new" data-tag-suggestions-item data-tag-suggestions-item-default></li>'
        );
        $el.append($('<span data-tag-suggestions-item-name></span>').text(name.trim()));
        return $el;
    };

    // Trigger click on current active item if user hits <RETURN>
    this.confirm = function() {
        if (this.select('activeSuggestedTagSelector').length > 0) {
            this.select('activeSuggestedTagSelector').trigger('click');
        } else {
            this.trigger('uiAttemptSelectFromInput');
        }
    };

    // Highlight previous item in suggestion list
    this.moveUp = function() {
        const $suggestions = this.select('suggestedTagSelector');
        const $activeSuggestion = this.select('activeSuggestedTagSelector');

        $activeSuggestion.removeAttr('data-active');

        if ($activeSuggestion.length && $activeSuggestion.prev().length) {
            $activeSuggestion.prev().attr('data-active', true);
        } else {
            $suggestions.last().attr('data-active', true);
        }
    };

    // Highlight next item in suggestion list
    this.moveDown = function() {
        const $suggestions = this.select('suggestedTagSelector');
        const $activeSuggestion = this.select('activeSuggestedTagSelector');

        $activeSuggestion.removeAttr('data-active');

        if ($activeSuggestion.length && $activeSuggestion.next().length) {
            $activeSuggestion.next().attr('data-active', true);
        } else {
            $suggestions.first().attr('data-active', true);
        }
    };

    this.after('initialize', function() {
        // Show / hide list in various situations
        this.on('uiTagInputFocused', this.showSuggestions);
        this.on('uiSuggestionsAbort', this.hideSuggestions);
        this.on('uiSuggestionsReady', this.showSuggestions);
        this.on('uiSuggestionsEmpty', this.hideSuggestions);

        // Execute user keyboard inputs on list
        this.on('uiSuggestionsConfirm', this.confirm);
        this.on('uiSuggestionsMoveUp', this.moveUp);
        this.on('uiSuggestionsMoveDown', this.moveDown);

        // Suggestions data received
        this.on('dataSuggestionsDataServed', this.suggestionsDataServed);

        // Select suggestion when user clicks a list item
        this.on('click', {
            suggestedTagSelector: this.suggestionSelected,
        });
    });
}

export default flight.component(TagSuggestions);



// WEBPACK FOOTER //
// ./src/js/component_ui/tag-suggestions.js